import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { keyEmptyCheck } from 'aurora-utils/utils';

import styles from './styles';

/** ****************
Props Documentation:
--------------------
title : title of the accordion
***************** */

const AccordionLayout = ({ classes, children, title, required }) => {
  return (
    <Accordion
      // key={id}
      // style={{ order }}
      className={classes.accordion}
      classes={{
        expanded: classes.expandedAccordion,
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        // aria-controls={name}
        // id={id}
        className={classes.accordionSummary}
      >
        <Typography className={classes.accordionHeading}>
          {keyEmptyCheck(title)}
          {required && <span className={classes.textADGMRed}>*</span>}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
};

AccordionLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  required: PropTypes.string,
};

AccordionLayout.defaultProps = {
  required: false,
};

export default withStyles(styles)(AccordionLayout);
